import { ReactNode } from 'react';
import { IconCaret, IconPencil } from '@components/icons';
import { PillToggle, PillToggleVariant, SIZE_S } from '@components/pill-toggle';
import classNames from 'classnames';

export interface FormFieldRowMobileProps {
  label: ReactNode;
  isCustom: boolean;
  requirementVariant: PillToggleVariant;
  requirementLabel: string;
  /** Fires when the user taps the row. The parent opens the bottom-sheet modal. */
  onClick?: () => void;
  disabled: boolean;
  ariaLabel: string;
}

export const FormFieldRowMobile = ({
  label,
  isCustom,
  requirementVariant,
  requirementLabel,
  onClick,
  disabled,
  ariaLabel,
}: FormFieldRowMobileProps) => (
  <button
    type='button'
    aria-label={ariaLabel}
    onClick={onClick}
    disabled={disabled}
    data-testid='form-field-row-mobile-trigger'
    className={classNames(
      'flex w-full items-center xs:hidden text-left',
      disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
      'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary'
    )}>
    <div className='flex min-w-0 flex-1 items-center gap-1 px-2'>
      <span className='text-body-m truncate text-primary'>{label}</span>
      {isCustom && (
        <span aria-hidden className='inline-flex h-6 w-6 shrink-0 items-center justify-center text-primary'>
          <IconPencil className='h-4 w-4' />
        </span>
      )}
    </div>
    <div className='flex shrink-0 items-center gap-2 px-2'>
      <PillToggle variant={requirementVariant} label={requirementLabel} size={SIZE_S} />
      <IconCaret aria-hidden className='h-4 w-4 text-tertiary' />
    </div>
  </button>
);
